import React from "react";
import { Box, Button, IconButton, Typography } from "@material-ui/core";
import { Mic, MicOff } from "@material-ui/icons";
import { useSelector } from "../../../../store";
import { toggleMicrophone } from "./../../../../utils/webRTCHandler";

const MicButton = () => {
  const { micState } = useSelector((state) => state.room);

  const handleMicButtonPressed = () => {
    toggleMicrophone();
  };

  const handleTouchEnd = (e) => {
    e.preventDefault();
    handleMicButtonPressed();
  };

  return (
    <Box
    >
      <Button
        sx={{
          color: "white",
          boxShadow: "none",
        }}
        variant="contained"
        onClick={handleMicButtonPressed}
        onTouchEnd={handleTouchEnd}
        id="iconnect-mic-button"
      >
        <Box sx={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
          {!micState ? <MicOff /> : <Mic />}
          <Typography sx={{ mt: 0, fontSize: "12px" }}>
            {micState ? "Mute" : "Unmute"}
          </Typography>
        </Box>

      </Button>
    </Box>
  );
};

export default MicButton;
